import AppRecord from './AppRecord.js'

class AifTransaction extends AppRecord {
}

export default AifTransaction
